import { render, staticRenderFns } from "./GroupCard.vue?vue&type=template&id=76e4c1a6"
import script from "./GroupCard.vue?vue&type=script&lang=js"
export * from "./GroupCard.vue?vue&type=script&lang=js"
import style0 from "./GroupCard.vue?vue&type=style&index=0&id=76e4c1a6&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76e4c1a6')) {
      api.createRecord('76e4c1a6', component.options)
    } else {
      api.reload('76e4c1a6', component.options)
    }
    module.hot.accept("./GroupCard.vue?vue&type=template&id=76e4c1a6", function () {
      api.rerender('76e4c1a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/catalog/components/GroupCard.vue"
export default component.exports